export const associatedContractsHeaderOptions = [
  { label: 'Un-Associate', value: 'Un-Associate', callback: 'onClickAdd' }
];
